import { render } from "./CustomerBase.vue?vue&type=template&id=55a32098&scoped=true"
import script from "./CustomerBase.vue?vue&type=script&lang=js"
export * from "./CustomerBase.vue?vue&type=script&lang=js"

import "./CustomerBase.vue?vue&type=style&index=0&id=55a32098&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a32098"]])

export default __exports__